/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_3_TInputs */

const en_cp_why_3_t = /** @type {(inputs: Cp_Why_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A committed client`)
};

const id_cp_why_3_t = /** @type {(inputs: Cp_Why_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klien yang berkomitmen`)
};

/**
* | output |
* | --- |
* | "A committed client" |
*
* @param {Cp_Why_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_3_t = /** @type {((inputs?: Cp_Why_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_3_t(inputs)
	return en_cp_why_3_t(inputs)
});